<template>
  <div id="app">
    <main class="app-main">
      <router-view />
    </main>
    <CompanyFooter :show-address="showCompanyAddress" />
  </div>
</template>


<script>
import CompanyFooter from "@/components/CompanyFooter.vue";

export default {
  name: 'App',
  components: { CompanyFooter },
  computed: {
    showCompanyAddress() {
      return ['about', 'contentPolicy', 'refund', 'terms', 'privacy'].includes(this.$route.name);
    },
  },
}
</script>

<style>
html,
body,
#app {
  min-height: 100%;
}

body {
  margin: 0;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1 0 auto;
}
</style>
